import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CompanyOfferModel } from './models/company-offer.model';

export interface CompanyOfferState extends EntityState<CompanyOfferModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'offer', idKey: 'OfferId', cache: { ttl: 20000 } })
export class CompanyOfferStore extends EntityStore<CompanyOfferState> {
  constructor() {
    super();
  }
}
